import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import SearchForm from '../../../../components/search-form';

import ProgressBar from '../../../../components/progress-bar';
import { getOpportunityQueryExplainations } from '../../SetupActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';

class QueryExplantionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      loading: false,
      error: null,
      results: null,
    };
    this.close = this.close.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  close() {
    this.props.onClose();
  }
  
  loadData() {
    const { organization, settings, opportunity, automationId } = this.props;
    if (!this.state.loading) {
      this.setState({ loading: true, loaded: false }, () => {
        this.props.dispatch(getOpportunityQueryExplainations(organization._id, opportunity.opportunity_id, settings, automationId))
          .then(
            (results) => {
              this.setState({ error: null, results, loading: false, loaded: true });
            },
            (e) => {
              this.setState({ results: null, loading: false, loaded: false, error: e.data?.message || e.message });
            },
          );
      });
    }
  }

  renderResults() {
    const { results } = this.state;
    return (
      <div>
        <table className="table table-condensed table-striped">
          <tr>
            <th width="300">Automation Trigger Conditions:</th>
            <td className="text-left"><span className={`label ${(results.results ? 'label-success' : 'label-danger animated flash')}`}>{(results.results ? 'Passed' : 'Failed')}</span></td>
          </tr>
        </table>
        <SearchForm
          onSearchChange={() => {}}
          disabled
          readOnly
          standalone
          simpleMode
          defaultCriteria={results}
          type="automations/test-account-discovery-bot"
        />
      </div>
    );
  }


  render() {
    const { loading, loaded, error } = this.state;

    let body = null;

    if (loading) {
      body = (<div style={{ overFlow: 'hidden' }}><ProgressBar /></div>);
    } else if (!loaded) {
      body = null;
      if (error) {
        body = (
          <div className="alert alert-danger">{error}</div>
        );
      }
    } else {
      body = this.renderResults();
    }

    let title = 'Trigger Condition';
    if (this.props.opportunity) {
      title = `Trigger Condition for: ${this.props.opportunity.name}`;
    }

    return (
      <Modal bsSize="lg" show={this.props.show} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>{title}</h4>
        </Modal.Header>
        <Modal.Body>
          {body}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.close} bsStyle="default">Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

QueryExplantionModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    account_id: PropTypes.string.isRequired,
  }).isRequired,
  show: PropTypes.bool,
  settings: PropTypes.shape({}),
  onClose: PropTypes.func,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  automationId: PropTypes.string,
};
QueryExplantionModal.defaultProps = {
  show: false,
  settings: {},
  onClose: () => {},
  automationId: null,
};

export default connect(mapStateToProps)(QueryExplantionModal);
